var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.77495 5.80804C1.65647 5.69764 1.49977 5.63754 1.33785 5.6404C1.17593 5.64325 1.02145 5.70885 0.906935 5.82336C0.792425 5.93787 0.726831 6.09236 0.723974 6.25427C0.721117 6.41619 0.78122 6.5729 0.89162 6.69138L4.64162 10.4414C4.75881 10.5584 4.91766 10.6242 5.08329 10.6242C5.24891 10.6242 5.40777 10.5584 5.52495 10.4414L14.6916 1.27471C14.802 1.15623 14.8621 0.999525 14.8593 0.837607C14.8564 0.67569 14.7908 0.521202 14.6763 0.406691C14.5618 0.29218 14.4073 0.226587 14.2454 0.22373C14.0835 0.220873 13.9268 0.280976 13.8083 0.391376L5.08329 9.11638L1.77495 5.80804Z",
    fill: "#49CC90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.c88a4d5b1d29721ff9cec45fd3716c44.svg";
export { ForwardRef as ReactComponent };